// extracted by mini-css-extract-plugin
export default {"modal-form":"styles_modal-form__t9Iav","root":"styles_root__qs5AP"};